import "core-js/modules/es7.object.values";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartLine',
  props: {
    value: Object,
    text: String,
    lineName: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null,
      option: {}
    };
  },
  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          if (newVal) {
            this.setOption(newVal);
          } else {
            this.setOption(oldVal);
          }
        } else {
          this.init();
        }
      },
      deep: true
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setOption: function setOption(value) {
      var xAxisData = Object.keys(value);
      var seriesData = Object.values(value);
      this.option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData,
          name: this.lineName,
          type: 'line'
        }]
      };
      this.dom.showLoading();
      this.dom.setOption(this.option);
      this.dom.hideLoading();
    },
    init: function init() {
      var xAxisData = Object.keys(this.value);
      var seriesData = Object.values(this.value);
      this.option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} '
        },
        // dataZoom: [
        //   {
        //     show: true,
        //     start: 94,
        //     end: 100
        //   },
        //   {
        //     type: 'inside',
        //     start: 94,
        //     end: 100
        //   },
        //   {
        //     show: true,
        //     yAxisIndex: 0,
        //     filterMode: 'empty',
        //     width: 30,
        //     height: '80%',
        //     showDataShadow: false,
        //     left: '93%'
        //   }
        // ],
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData,
          name: this.lineName,
          type: 'line'
        }]
      };
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.showLoading();
      this.dom.setOption(this.option);
      this.dom.hideLoading();
      on(window, 'resize', this.resize);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};